// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__17OmH","row":"styles_row__2MPIq"};